export const ONDEMAND_REQUEST = 'ONDEMAND_REQUEST';
export const ONDEMAND_REQUEST_SUCCESS = 'ONDEMAND_REQUEST_SUCCESS';
export const ONDEMAND_REQUEST_ERROR = 'ONDEMAND_REQUEST_ERROR';

export const CLEAR_DATA = 'CLEAR_DATA';

export const ONDEMAND_HEALTH_RECORD_REQUEST = 'ONDEMAND_HEALTH_RECORD_REQUEST';
export const ONDEMAND_HEALTH_RECORD_REQUEST_SUCCESS = 'ONDEMAND_HEALTH_RECORD_REQUEST_SUCCESS';
export const ONDEMAND_HEALTH_RECORD_REQUEST_ERROR = 'ONDEMAND_HEALTH_RECORD_REQUEST_ERROR';

export const LIST_ONDEMAND_HEALTH_RECORD_REQUEST = 'LIST_ONDEMAND_HEALTH_RECORD_REQUEST';
export const LIST_ONDEMAND_HEALTH_RECORD_REQUEST_SUCCESS = 'LIST_ONDEMAND_HEALTH_RECORD_REQUEST_SUCCESS';
export const LIST_ONDEMAND_HEALTH_RECORD_REQUEST_ERROR = 'LIST_ONDEMAND_HEALTH_RECORD_REQUEST_ERROR';